module.exports = __webpack_public_path__ + "media/images/webinar/mcdermott-e9af0d04f796abda07ffb02dc646b846.jpg";